// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/es6.array.is-array.js
// module id = 48
// module chunks = 0